export default __webpack_public_path__ + "static/media/all-icon-active.5112c822.webp";